import ProductDetailsTab from './ProductDetailsTab';
export default ProductDetailsTab;
